import Clickable from '@/components/Clickable';
import { useApplicationContainer } from 'containers/ApplicationContainer';
import { CSSProperties, MouseEvent, ReactNode } from 'react';

interface LoginLinkProps {
  children?: ReactNode;
  className?: string;
  style?: CSSProperties;
}

export default function LoginLink({ children, className, style }: LoginLinkProps) {
  const [, { handleOpenLoginModal }] = useApplicationContainer();

  function handleClick() {
    handleOpenLoginModal();
  }

  return (
    <div style={style}>
      <Clickable className={className} onClick={handleClick}>
        {children || 'Login'}
      </Clickable>
    </div>
  );
}
